const l = {
  name: "Recycle",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.3 39.7" style="enable-background:new 0 0 39.3 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.6,0h8.1l8.1,14l1.6-5.9l1.9,0.5l-2.5,9.2l-9.2-2.5l0.5-1.9L30,15L22.5,2h-5.8l-3.2,5.6l-1.7-1L15.6,0z"/>
		<path class="st0" d="M8.1,13l-5.9,1.6l-0.5-1.9l9.2-2.5l2.5,9.2l-1.9,0.5L9.8,14L2.3,27c0.6,1.1,1,1.8,1.4,2.5l0,0
			c0.4,0.7,0.8,1.4,1.4,2.5h6.4v2H4l-0.3-0.5c-0.8-1.3-1.3-2.2-1.7-3c-0.5-0.8-1-1.7-1.7-3L0,27L8.1,13z"/>
		<path class="st0" d="M39.3,27l-3.8-6.6l-1.7,1L37,27c-0.6,1-1,1.8-1.4,2.5l0,0l0,0l0,0l0,0c-0.4,0.7-0.8,1.4-1.4,2.5H19l4.3-4.3
			l-1.4-1.4L15.2,33l6.7,6.7l1.4-1.4L19,34h16.2l0.3-0.5c0.8-1.3,1.3-2.2,1.7-3l0,0c0.5-0.8,1-1.7,1.7-3L39.3,27z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Recycle
};
